// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TZ2k","tabsBox":"styles_tabsBox__2ykNz","createButton":"styles_createButton__1Bl17"};